import React, { useEffect } from "react";
import { DataGrid, deDE, GridCellParams, GridColDef, GridRowParams, GridSortModel, GridValueGetterParams, LocalizationV4 } from "@material-ui/data-grid";

import Grid from "@material-ui/core/Grid";
import {
  Button,
  Container,
  FormControl,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  Tooltip,
  Checkbox,
  FormControlLabel,
  CircularProgress
} from "@material-ui/core";

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import {
  getAnlageListe,
  selectAnlageListe,
  selectEditEntry,
  selectNewEntry,
  selectAktuelleAnlage,
  selectViewMode,
  selectEditDirty,
  setEditEntry,
  updateAktuelleAnlage,
  createAnlage,
  updateAnlage,
  setTyp,
  getUWs,
  setName,
  setUW,
  setAktiv,
  setBeschreibung,
  setKommentar,
  discardNew,
  discardChanges,
  startNewEntry,
  deleteAnlage,
  setError,
  resetError,
  selectError,
  anlageDummy,
  selectUWs,
  selectAnlagentyp,
  getAnlagentypen,
  selectListLoading,
  selectAnlagentypentLoading,
  selectUmspannwerkLoading,
  selectSorting,
  setSorting,
  resetViewMode
} from "./anlagenSlice";

import { useStyles } from "./../wertelisteStyles";
import { useMsal } from "@azure/msal-react";
import { anlage, anlagentyp, umspannwerk } from "../../../../utils/apiTypes";
import { validate, validateHelper } from "../../../../features/validate/validate";
import { globalStyles } from "../../../../assets/globalStyles";
import { Autocomplete } from "@material-ui/lab";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { rollen, isAuthorized } from "../../../../utils/auth/authConfig";


export const Anlagen: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const rollenObj = rollen;

  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);

  useEffect(() => {
    dispatch(getAnlageListe())
    dispatch(getUWs())
    dispatch(getAnlagentypen())
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  const
    uwSelectList: umspannwerk[] = useAppSelector(selectUWs),
    anlageSelectListe: anlage[] = useAppSelector(selectAnlageListe),
    anlagentypSelectListe: anlagentyp[] = useAppSelector(selectAnlagentyp),
    editEntry: boolean = useAppSelector(selectEditEntry),
    newEntry: boolean = useAppSelector(selectNewEntry),
    aktuelleAnlage: anlage = useAppSelector(selectAktuelleAnlage),
    viewMode: boolean = useAppSelector(selectViewMode),
    dirtyEdit: number = useAppSelector(selectEditDirty),
    inputError: boolean = useAppSelector(selectError),
    listLoading: boolean = useAppSelector(selectListLoading),
    uwLoading: boolean = useAppSelector(selectUmspannwerkLoading),
    anlagentypenLoading: boolean = useAppSelector(selectAnlagentypentLoading),
    sorting: GridSortModel = useAppSelector(selectSorting);

  const dataGridCols2: GridColDef[] = [
    {
      field: 'aktiv', headerName: 'Aktiv', flex: 0.7, align: "center", renderCell: function status(params: GridCellParams) {
        return (<React.Fragment>
          {params.getValue(params.id, 'aktiv') ?
            <Tooltip title="Aktiv">
              <FiberManualRecordIcon color="secondary" />
            </Tooltip>
            : ""}</React.Fragment>)
      },
      sortComparator: (v1, v2, param1, param2) => {
        const p1 = param1.api.getCellValue(param1.id, 'aktiv') ? 1 : 0;
        const p2 = param1.api.getCellValue(param2.id, 'aktiv') ? 1 : 0;
        return p2 - p1;
      }, filterable: false
    },
    { field: 'name', headerName: 'Name', flex: 2 },
    { field: 'beschreibung', headerName: 'Beschreibung', flex: 2, filterable: false },
    { field: 'umspannwerk', headerName: 'Umspannwerk', flex: 2 },
    {
      field: 'anlagentyp', headerName: 'Typ', flex: 0.8, valueGetter: (params: GridValueGetterParams) => {
        return anlagentypSelectListe.length == 0 ? "Wird geladen..." : (anlagentypSelectListe.find((at: anlagentyp) => at.id == params.row.anlagentyp)?.typ);
      }
    },
    { field: 'kommentar', headerName: 'Kommentar', flex: 2, filterable: false }
  ]

  function printTableAnlage(data: anlage[]) {
    return (

      <Container maxWidth={false} className={classes.root}>
        <div style={{ height: "50vh", width: '100%' }}>
          <DataGrid
            localeText={(deDE as LocalizationV4).props.MuiDataGrid.localeText}
            disableColumnMenu={false}
            disableColumnSelector={true}
            columns={dataGridCols2}
            loading={listLoading}
            rows={data}
            sortModel={sorting}
            onSortModelChange={(model) => setSorting(model.sortModel)}
            onRowClick={(param: GridRowParams) => {
              let mt = anlageDummy;
              const temp = data.find(mst => mst.id == (param.row.id as number))
              if (temp)
                mt = temp;
              if (!editEntry) dispatch(updateAktuelleAnlage(mt));
            }} />
        </div>
      </Container>
    );
  }

  function printSaveDiscardButtons() {
    return (<div>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(createAnlage(aktuelleAnlage)) : dispatch(updateAnlage(aktuelleAnlage)) }}
        color="secondary"
        className={classes.showtriButton}
        disabled={
          aktuelleAnlage.name == ""
          || aktuelleAnlage.umspannwerk == ""
          || aktuelleAnlage.anlagentyp == -1
          || !dirtyEdit
          || inputError}
        style={{ minHeight: "36px" }}
      >
        {listLoading ? <CircularProgress size="20px" style={{ padding: "1px" }} /> : "Speichern"}
      </Button>
      <Button
        variant="contained"
        onClick={() => { newEntry ? dispatch(discardNew()) : dispatch(discardChanges()) }}
        color="secondary"
        className={classes.showtriButton}
      >
        Abbrechen
      </Button>
    </div>)
  }
  function confirmDeleteOfMessgeraet() {
    dispatch(deleteAnlage(aktuelleAnlage));
    setOpenDeleteDialog(false);
  }

  function printEditDeleteButton() {
    if (isAuthorized([rollenObj.admin, rollenObj.technik, rollenObj.netzwirtschaft]))
      return (
        <div>

          <Button
            variant="contained"
            onClick={() => dispatch(setEditEntry())}
            color="secondary"
            className={classes.showtriButton}
          >
            Bearbeiten
          </Button>
          <Button
            variant="contained"
            onClick={() => setOpenDeleteDialog(true)}
            color="secondary"
            className={`${classes.backgroundColorErrorDark} ${classes.showtriButton}`}
          >
            Löschen
          </Button>
          <Dialog
            open={openDeleteDialog}
            onClose={() => setOpenDeleteDialog(false)}
          >
            <DialogTitle>Angeschlossene Anlagen löschen</DialogTitle>
            <DialogContent>
              <DialogContentText>
                {'Sind Sie sicher, dass Sie die Angeschlossene Anlagen "' +
                  aktuelleAnlage.name +
                  '" wirklich löschen wollen?'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="secondary"
                variant="contained"
                onClick={() => setOpenDeleteDialog(false)}
                className={classes.cancleDeleteButton}
              >
                Abbrechen
              </Button>
              <Button
                variant="contained"
                onClick={confirmDeleteOfMessgeraet}
                className={classes.confirmDeleteButton}
                style={{ minWidth: "120px", minHeight: "36px" }}
              >
                {listLoading ? <CircularProgress size="20px" style={{ color: "black" }} /> : "Löschen"}
              </Button>
            </DialogActions>
          </Dialog>
          <Button
            variant="contained"
            onClick={() => { dispatch(resetViewMode()) }}
            color="default"
            className={classes.showtriButton}
          >
            Schließen
          </Button>
        </div>
      );
    else return (<React.Fragment />)
  }

  function printEdit() {
    return (
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px", marginBottom: "10px" }} >
        <form className={classes.root} noValidate autoComplete="off" style={{ marginLeft: "16px", marginRight: "16px", marginBottom: "10px" }}>
          <div>
            <Grid container spacing={4} >
              <Grid item container xs={12}>
                <Grid item md={3}>
                  <Typography color="primary" variant="h6" className={classes.typoH6Style} component={"div"} >
                    {newEntry ? "Neue Angeschlossene Anlagen anlegen" : "Bearbeiten von Angeschlossene Anlagen: " + aktuelleAnlage.name}
                  </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={6} className={classes.justifyEnd} >
                  {editEntry ? printSaveDiscardButtons() : printEditDeleteButton()}
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs className={classes.justifyItems}>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    required={true}
                    id="anlage-name"
                    disabled={editEntry ? false : true}
                    label="Name"
                    error={validate(dispatch, setError, resetError, aktuelleAnlage.name, "name")}
                    helperText={validateHelper(aktuelleAnlage.name)}
                    variant="outlined"
                    onChange={(event) => dispatch(setName(event.target.value))}
                    value={aktuelleAnlage.name}
                  />
                </FormControl>
              </Grid>

              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    id="select-anlagen-uw"
                    disabled={editEntry ? false : true}
                    value={aktuelleAnlage.umspannwerk}
                    noOptionsText={<React.Fragment>
                      {uwLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Umspannwerke"}</React.Fragment>
                    }
                    onChange={(event, newValue) => {
                      if (newValue) dispatch(setUW(newValue));
                    }}
                    inputValue={uwSelectInputValue}
                    onInputChange={(event, newInputValue) => {
                      setUwSelectInputValue(newInputValue);
                    }}
                    options={uwSelectList.map((x) => x.name)}
                    getOptionLabel={(option) => (option ? option : "")}
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        {...params}
                        label="Umspannwerk"
                        variant="outlined"
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <Autocomplete
                    id="select-anlagentyp"
                    noOptionsText={<React.Fragment>
                      {anlagentypenLoading ? <CircularProgress style={{ padding: "5px" }} /> : "Keine Anlagentypen"}</React.Fragment>
                    }
                    disabled={editEntry ? false : true}
                    value={anlagentypSelectListe.find((x: anlagentyp) => x.id == aktuelleAnlage.anlagentyp)}
                    onChange={(_, newValue) => {
                      if (newValue) dispatch(setTyp(newValue.id));
                    }}
                    inputValue={anlagentypSelectInputValue}
                    onInputChange={(_, newInputValue) => {
                      setAnlagentypSelectInputValue(newInputValue);
                    }}
                    options={anlagentypSelectListe}
                    getOptionLabel={(option) => option ? option.typ : ""}
                    renderInput={(params) => <TextField required={true} {...params} label="Anlagentyp" variant="outlined" />}
                  />
                </FormControl>
              </Grid>
              <Grid item xs>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={aktuelleAnlage.aktiv}
                      onChange={(_, newValue) => {
                        if (newValue !== null && newValue !== undefined) dispatch(setAktiv(Boolean(newValue)))
                      }}
                      disabled={editEntry ? false : true} />}
                  label="Aktiv"
                />

              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    id="anlage-beschreibung"
                    disabled={editEntry ? false : true}
                    label="Beschreibung"
                    error={validate(dispatch, setError, resetError, aktuelleAnlage.beschreibung, "beschreibung")}
                    helperText={validateHelper(aktuelleAnlage.beschreibung)}
                    variant="outlined"
                    onChange={(event) => dispatch(setBeschreibung(event.target.value))}
                    value={aktuelleAnlage.beschreibung}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs>
                <FormControl className={classes.fullWidth}>
                  <TextField
                    disabled={editEntry ? false : true}
                    id="anlage-kommentar"
                    multiline
                    rows={4}
                    rowsMax={8}
                    label="Kommentar"
                    error={validate(dispatch, setError, resetError, aktuelleAnlage.kommentar, "kommentar")}
                    helperText={validateHelper(aktuelleAnlage.kommentar)}
                    variant="outlined"
                    onChange={(event) => dispatch(setKommentar(event.target.value))}
                    value={aktuelleAnlage.kommentar ? aktuelleAnlage.kommentar : ""}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    )
  }

  const [anlagentypSelectInputValue, setAnlagentypSelectInputValue] = React.useState('');
  const [uwSelectInputValue, setUwSelectInputValue] = React.useState("");
  return (
    <div>
      {viewMode ? printEdit() : ""}
      <Paper className={classes.paper} style={{ marginBottom: "10px", marginLeft: "24px", marginRight: "24px" }}>
        <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "0px" }}>
          <Grid item md={3} >
            <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
              Angeschlossene Anlagen Übersicht
            </Typography>
          </Grid>
          <Grid item md={3} />
          <Grid item md={6} style={{ paddingRight: "24px", paddingTop: "0px" }}>
            <Grid item container md={12}>
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3} />
              <Grid item md={3}>
                {isAuthorized([rollenObj.admin, rollenObj.technik, rollenObj.netzwirtschaft]) ?
                  <Button
                    variant="contained"
                    onClick={() => dispatch(startNewEntry())}
                    color="secondary"
                    className={classes.showButton}
                    disabled={editEntry}
                  >
                    Hinzufügen
                  </Button>
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          {printTableAnlage(anlageSelectListe)}
        </Grid>
      </Paper>
    </div>
  );
}
